

export function createPurchaseOrderEquipmentList(orderItems) {

    let list = []

    orderItems.forEach(item => {

        let listItem = {
            ...item,
            ...item.equipment,
            equipmentId: item.equipment.id
        }

        list.push(listItem)
    })

    return list
}

export function createSubmitData(formData) {

    let logs = []

    formData.equipment.forEach(item => {

        let log = {
            dateAndTime: `${formData.date.format("YYYY-MM-DD")}T${formData.time.format("HH:mm:ss")}`,
            quantity: parseInt(item.quantityReceived, 10),
            equipment: parseInt(item.equipmentId ? item.equipmentId : item.id, 10),
            fromJob: formData.forJob ? parseInt(formData.forJob, 10) : null,
            fromPurchaseOrder: formData.fromPurchaseOrder ? parseInt(formData.fromPurchaseOrder, 10) : null
        }

        logs.push(log)
    })

    return { logs }
}
